import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { Locations, transformLinkUri } from "gatsby-theme-gba"

const apiKey = process.env.GATSBY_GOOGLE_MAP_API

const prepareLocations = (locations, blok) => {
  for (let i = 0; i < locations.length; i++) {
    if (locations[i]["body"]) {
      locations[i]["body"] = (
        <Markdown
          transformLinkUri={(uri) => {
            return transformLinkUri(uri, "", blok.currentLanguage)
          }}
        >
          {locations[i]["body"]}
        </Markdown>
      )
    }
  }

  //filter for componentVisibility
  const fiteredLocation = locations.filter((location) => {
    let teasersVisibility = location.componentVisibility || []
    if (
      teasersVisibility.length === 0 ||
      teasersVisibility.includes(blok.currentLanguage)
    ) {
      return true
    } else {
      return false
    }
  })

  return fiteredLocation
}

const LocationsEditable = ({ blok }) => {
  const backgroundImage = "/block-3rd-party-maps.jpg"

  let link = ""
  if (blok.infoUrl) {
    link = blok.infoUrl.id
      ? transformLinkUri(blok.infoUrl.id, "", blok.currentLanguage)
      : blok.infoUrl.cached_url
  }

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <Locations
        heading={blok.heading}
        mode={blok.mode}
        centerLng={Number(blok.centerLng)}
        ceneterLat={Number(blok.centerLat)}
        zoomLevel={Number(blok.zoom)}
        location={prepareLocations(blok.location, blok)}
        apiKey={apiKey}
        currentLanguage={blok.currentLanguage}
        hideMap={blok.hideMap}
        hideLocations={blok.hideLocations}
        thirdPartyInfo={{
          cookieKey: blok.cookieKey,
          backgroundUrl: backgroundImage,
          buttonText: blok.buttonText,
          buttonPermanentText: blok.buttonPermanentText,
          infoText: blok.infoText,
          infoUrl: link,
          infoUrlText: blok.infoUrlText,
          block3rdParty: blok.block3rdParty,
        }}
      />
    </div>
  )
}

export default LocationsEditable
